import { ACTIONS } from "../../common/constants";

const cdtFiltersDataReducer = function (state = {}, action) {
  switch (action.type) {
    case ACTIONS.SET_CDT_FILTERS:
      return action.data;
    default:
      return state;
  }
};

export default cdtFiltersDataReducer;
